import React, { useCallback } from 'react';

import { Stack } from '@lyearn/ui';
import * as ActionItem from '@/modules/tasks/features/actionItems/components/ActionItem';
import { ActionItemFragment } from '@/modules/tasks/features/actionItems/graphql/fragments/generated/ActionItem';

interface TaskRowProps {
  rowData: ActionItemFragment;
  cells: React.ReactNode;
  onClick: (taskId: string) => void;
}

function TaskRow(props: TaskRowProps) {
  const { rowData, cells } = props;
  const onClick = useCallback(() => {
    props.onClick(rowData.id);
  }, [props, rowData.id]);

  return (
    <Stack
      className="task-list w-full flex-shrink-0 cursor-pointer rounded-8 py-6 hover:bg-bg-secondary"
      onClick={onClick}>
      <ActionItem.Provider isReadOnly actionItem={rowData}>
        {cells}
      </ActionItem.Provider>
    </Stack>
  );
}

export default React.memo(TaskRow);
